import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        offices: [],
        embassyOffices: [],
        officeRates:[],
        currency:null
    }
}

const getters = {
    offices: state => state.offices,
    embassyOffices: state => state.embassyOffices,
    officeRates: state => state.officeRates,
    currency: state => state.currency,
};

const actions = {
    fetchOffices({commit, state}) {
        Http.get(API_URL + VERSION + '/arrival-offices')
            .then(response => {
                commit('setOffices', response.data)
            })

    },
    fetchEmbassyoffices({commit}) {
        Http.get(API_URL + VERSION + "/embassy/offices")
            .then(response => {
                commit('setEmbassyOffices', response.data);
        });
    },
    fetchOfficeRate({commit}, office) {
    Http.get(API_URL + VERSION + '/office-rate', {
        params: {
            office_id: office
        }
    })
        .then(response => {
            commit('setOfficeRate', response.data.data);
            commit('setCurrency', response.data.currency);
        })
}
};

const mutations = {
    setOffices(state, items) {
        state.offices = items
    },
    setEmbassyOffices(state, items) {
        state.embassyOffices = items
    },
    setOfficeRate(state, items) {
        state.officeRates = items
    },
    setCurrency(state, items) {
        state.currency = items
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
